import gql from 'graphql-tag';
export const UPDATE_USER = gql `
  mutation updateUserMutation($user: UpdateUserInput!) {
    updateUser(input: $user) {
      user {
        id
        firstName
        lastName
        email
        countryCode
        company {
          id
          tenantId
        }
        locale
        phone
        addressLine1
        addressLine2
        zipCode
        city
        state
        roles
        agreements {
          serviceAgreements
        }
        settings {
          preferredAppId
          timeFormat
          dateFormat
          regionalSettingsName
        }
        personas
      }
    }
  }
`;
//# sourceMappingURL=update.user.js.map